import { $$ } from '../../shared/js/utils/dom';
import Bus from '../../shared/js/modules/event-bus';
import { FocusRedirect } from '../../shared/js/modules/focus-redirect';
import { currentBreakpoint } from '../../shared/js/globals/breakpoints';

const redirectInstances = [];

const initRedirects = redirectElements => {
  const redirects = redirectElements || $$('[data-focus-redirect]');
  redirects.forEach(redirect => {
    const config = getFocusRedirectData(redirect);
    if (!config) return;
    const instance = new FocusRedirect(redirect, config);
    redirectInstances.push(instance);
    instance.activate();
  });
};

const getFocusRedirectData = el => {
  if (!el) return;
  const dataString = el.dataset.focusRedirect
    .replaceAll("'", '"')
    .replaceAll('`', "'");
  const dataObject = JSON.parse(dataString);

  // Fallback to next below breakpoint config if none is available for current breakpoint
  const defaultConfig = dataObject;
  const smartphoneConfig = dataObject.smartphone || dataObject;
  const tabletConfig = dataObject.tablet || smartphoneConfig;
  const desktopConfig = dataObject.desktop || tabletConfig;
  const bigscreenConfig = dataObject.bigscreen || desktopConfig;
  const breakpoint = currentBreakpoint;

  if (breakpoint === 'smartphone') return smartphoneConfig;
  if (breakpoint === 'tablet') return tabletConfig;
  if (breakpoint === 'desktop') return desktopConfig;
  if (breakpoint === 'bigscreen') return bigscreenConfig;
  return defaultConfig;
};
const onResizeHandler = () => {
  redirectInstances.forEach(instance => {
    const config = getFocusRedirectData(instance.el);
    if (!config) return;
    instance.updateConfig(config);
  });
};

Bus.subscribe('resize', 'FocusRedirectResize', onResizeHandler);

export { initRedirects };
